import React from 'react';
import FeatureFlagPlaceholder from 'components/ui/FeatureFlagPlaceholder';

export default function RWATokenisation() {
  return (
    <FeatureFlagPlaceholder
      title="RWA Tokenisation"
      description="Real-world asset tokenisation with compliance guardrails, regulatory mapping, and institutional-grade custody integration will be available in Phase 2."
      phase="Phase 2"
    />
  );
}
